export default __webpack_public_path__ + "static/media/audio-5.acb98bcc.wav";